export default "__VITE_ASSET__D1f1sQhX__"